import _ from 'lodash';
import React, { PureComponent } from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import IconPainel from "../../images/icon-tv-WHITE.svg";
import { estabelecimentoService } from "../../_services/estabelecimento.service";
import FormSelectInput from "../inputs/FormSelectInput";
import InputViewEdit from "../inputs/InputViewEdit";
import { userService } from '../../_services/user.service';

const modifiers = {
  preventOverflow: {
    enabled: false
  },
  flip: {
    enabled: false
  }
};

export class ModalLocal extends PureComponent<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      consultorio: null
    };
  }

  toogleModal = (idMarcacao, status) => {
    this.setState({ showModal: !this.state.showModal, idMarcacao, status });
  };

  fecharModal = () => {
    this.toogleModal(null, null);
  };

  handleSelectChange = (name: string, option: any) => {
    const { consultorio } = this.state;
    let newEntity = _.cloneDeep(consultorio);
    newEntity = option;
    this.setState({ consultorio: newEntity });
  };


  getValue = () => {
    const { estabelecimento } = this.props;

    if (this.state.consultorio) {
      return this.state.consultorio;
    } else {
      this.props.getLocal(estabelecimento.id)
    }
  }

  render() {
    const { estabelecimento } = this.props;
    const { consultorio, idMarcacao, status } = this.state;
    let _this = this;
    return (
      <React.Fragment>
        <Modal
          isOpen={this.state.showModal}
          toggle={this.toogleModal}
          backdrop="static"
          modalClassName=""
          className="modal-anexos"
          centered={true}
          modifiers={modifiers}
          target={this.props.target}
        >
          <ModalBody>
            <div className="">
              <div className="row">
                <div className="col-12 text-center iconLocal">
                  <img src={IconPainel} alt="Icone painel de chamada" />
                </div>
                <div className="col-12 text-center mb-2">
                  {/* <h2 className="font-weight-bold"> {`Selecionar Local de atendimento - ${estabelecimento.nome}`}</h2> */}
                  <h2 className="font-weight-bold">Em qual consultório você está?</h2>
                  <p>Selecione abaixo o consultório que você está atuando agora.
                    Este consultório será exibido para o paciente no painel de chamada.
                  </p>
                </div>
              </div>

              <React.Fragment>
                <div className="form-row">
                  <div className="col-12">
                    <InputViewEdit
                      component={FormSelectInput}
                      type="text"
                      name="consultorio"
                      label=""
                      placeholder="Selecione o consultorio ou sala"
                      onChange={this.handleSelectChange}
                      noSize={true}
                      viewMode={false}
                      id="consultorio"
                      returnFullObject={true}
                      service={estabelecimentoService.findLocalAtendimento}
                      labelKey={"nome"}
                      valueKey={"id"}
                      value={this.getValue()}
                      required={true}
                      parent={estabelecimento.id}
                    />
                  </div>
                </div>
              </React.Fragment>
            </div>
          </ModalBody>
          <ModalFooter>
            <React.Fragment>
              <div className="w-50 text-center">
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={() => {
                    this.fecharModal();
                  }}
                >
                  {" "}
                  Cancelar{" "}
                </button>
              </div>
              <div className="w-50 text-center">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    if (consultorio) {
                      _this.fecharModal();
                      _this.props.callbackOnSave(
                        estabelecimento.id,
                        consultorio,
                        idMarcacao,
                        status,
                          userService.getCurrentUser()
                      );
                    } else {
                      _this.props.error({
                        message: 'Selecione um local de atendimento.',
                      });
                    }
                  }}
                >
                  {" "}
                  Salvar{" "}
                </button>
              </div>
            </React.Fragment>
          </ModalFooter>
        </Modal>

        {/* ////////////////////////////////////////////////////// */}
      </React.Fragment>
    );
  }
}
